export default __webpack_public_path__ + "static/media/2052.85e83a78.png";